import { render, staticRenderFns } from "./Requisites.vue?vue&type=template&id=3a060005"
import script from "./Requisites.vue?vue&type=script&lang=js"
export * from "./Requisites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports